export default __webpack_public_path__ + "static/media/orange-arrow.d5b72f55.svg";